import { render, staticRenderFns } from "./JMATileCommon.vue?vue&type=template&id=50e5c8ab"
import script from "./JMATileCommon.vue?vue&type=script&lang=js"
export * from "./JMATileCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports